import {ref, computed} from 'vue'
import {defineStore} from 'pinia'
import {
  fetchAdsApi,
} from '@/service'

export const useAdsStore = defineStore('ads', () => {
  const ads = ref({})
  const activeScreening = ref(false)

  const fetchAds = async (id) => {
    return fetchAdsApi(id).then((response) => {
      ads.value = response && response.ad_config_display;
      return Promise.resolve(response)
    })
  }

  const isActiveScreening = computed(() => activeScreening.value)

  function setActiveScreening() {
    activeScreening.value = true
  }

  return {
    ads,
    fetchAds,
    setActiveScreening,
    isActiveScreening
  }
})
